(function () {
  function initialize(root) {
    if (root.dataset.productInitialized) return;
    root.dataset.productInitialized = 'true';
    var select = root.querySelector('[data-variant-select]');
    if (!select) return;
    var rules = JSON.parse(root.querySelector('[data-variant-rules]').textContent);
    function update() {
      var option = select.options[select.selectedIndex];
      if (!option) return;
      var available = option.dataset.available === 'true';
      root.querySelector('[data-variant-price]').textContent = option.dataset.price;
      var compare = root.querySelector('[data-variant-compare]');
      compare.textContent = option.dataset.compare;
      compare.hidden = !option.dataset.compare;
      var button = root.querySelector('[data-add-button]');
      button.disabled = !available;
      button.textContent = available ? 'Agregar al carrito' : 'Agotado';
      root.querySelector('[data-variant-status]').textContent = available ? 'Disponible' : 'Agotado';
      var rule = rules.find(function (item) { return String(item.id) === option.value; });
      var quantity = root.querySelector('[data-product-quantity]');
      if (rule) {
        quantity.min = rule.min || 1;
        quantity.step = rule.increment || 1;
        if (rule.max !== null && rule.max !== undefined) quantity.max = rule.max;
        else quantity.removeAttribute('max');
        quantity.value = rule.min || 1;
      }
      var url = new URL(window.location.href);
      url.searchParams.set('variant', option.value);
      window.history.replaceState(null, '', url);
    }
    select.addEventListener('change', update);

  }
  document.addEventListener('submit', async function (event) {
    var form = event.target;
    var root = form.closest('[data-product-detail]') || form.closest('[data-quick-add]');
    if (!root || form.tagName !== 'FORM') return;
    event.preventDefault();
    var button = form.querySelector('[type="submit"]');
    if (!button || button.disabled || form.dataset.addBusy || !form.reportValidity()) return;
    var message = form.querySelector('[data-add-message], [data-cart-error]');
    if (!message) {
      message = document.createElement('p'); message.setAttribute('role', 'status');
      message.setAttribute('data-add-message', ''); form.appendChild(message);
    }
    var label = button.textContent;
    form.dataset.addBusy = 'true'; button.disabled = true; button.textContent = 'Agregando…';
    message.hidden = true;
    form.setAttribute('aria-busy', 'true');
    try {
      var body = new FormData(form); body.delete('return_to');
      var response = await fetch(root.dataset.cartAddUrl, { method: 'POST', body: body, credentials: 'same-origin', headers: { Accept: 'application/json' } });
      var result = await response.json();
      if (!response.ok || result.status >= 400) throw new Error(result.description || result.message || 'No se pudo agregar el producto.');
      message.textContent = 'Producto agregado al carrito'; message.style.color = '#18743a'; message.hidden = false;
      message.setAttribute('role', 'status');
      try {
        var cartResponse = await fetch(root.dataset.cartUrl + '.js', { credentials: 'same-origin', cache: 'no-store', headers: { Accept: 'application/json' } });
        if (!cartResponse.ok) throw new Error('Cart count unavailable');
        var cart = await cartResponse.json();
        document.querySelectorAll('.stackerz-cart-count').forEach(function (badge) { badge.textContent = cart.item_count; });
        document.querySelectorAll('.stackerz-cart-link').forEach(function (link) { link.setAttribute('aria-label', 'Carrito: ' + cart.item_count + ' unidades'); });
      } catch (countError) { console.warn('Stackerz: no se pudo actualizar el contador.', countError); }
    } catch (error) {
      message.textContent = error.message || 'No pudimos confirmar la operación. Revisa tu carrito antes de volver a intentarlo.';
      message.style.color = '#b00020'; message.hidden = false; message.setAttribute('role', 'alert');
    } finally {
      delete form.dataset.addBusy; form.removeAttribute('aria-busy');
      var select = form.querySelector('[data-variant-select]');
      button.disabled = select ? select.options[select.selectedIndex].dataset.available !== 'true' : false;
      button.textContent = button.disabled ? 'Agotado' : label;
    }
  });
  function mount(scope) { scope.querySelectorAll('[data-product-detail]').forEach(initialize); }
  document.addEventListener('DOMContentLoaded', function () { mount(document); });
  document.addEventListener('shopify:section:load', function (event) { mount(event.target); });
}());
